export default "__VITE_ASSET__65df7a4f__"